/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJustifyCenter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m5 19 14 .001v2H5zm-3-4 20 .001v2H2zm20-3.999v2H2v-2zm0-4v2H2V7zm0-4v2H2V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgJustifyCenter as JustifyCenter };
